import styled from 'styled-components';

export default styled.div`
  display: flex;
  max-width: 600px;
`;
